export enum PlaidTokenCreationMode {
  Funding,
  ExternalAccounts
}
